import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  const handleScrollDown = () => {
    const overview = document.querySelector('#overview');
    if (overview) {
      overview.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleCTAClick = () => {
    const contact = document.querySelector('#contact');
    if (contact) {
      contact.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden" aria-label="Hero" data-id="element-69">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-70">
        <img src="https://cdn.magicpatterns.com/uploads/8iD82aMZDaV5HYXRLTYfEw/prodej-novostavby-v-nejvyssim-podlazi-s-velkou-terasou-a-2-balkony-obyvak-d3087d_(1).jpg" alt="Mezírka 3 — luxusní rezidenční projekt v Brně" className="w-full h-full object-cover" data-id="element-71" />
        {/* Overlay — always dark for readability over photo */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" data-id="element-72" />
      </div>

      {/* Content — always light text over dark overlay */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto" data-id="element-73">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-[#c9a96e] text-[13px] tracking-[0.3em] uppercase font-inter font-light mb-8" data-id="element-74">
          Rezidenční projekt — Mezírka 3, Brno
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="font-playfair text-[#f5f0eb] text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium tracking-[0.04em] mb-6" data-id="element-75">
          MEZÍRKA
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="font-inter text-[#f5f0eb]/70 text-lg md:text-xl font-light max-w-2xl mx-auto mb-4 leading-relaxed" data-id="element-76">
          Exkluzivní bydlení v srdci Brna. Pouze 3 bytové jednotky v
          nadstandardním provedení.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8,
        ease: 'easeOut'
      }} className="font-playfair text-[#c9a96e] text-2xl md:text-3xl font-medium mb-12" data-id="element-77">
          Předpokládané dokončení Q4 2026
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.0,
        ease: 'easeOut'
      }} data-id="element-78">
          <button onClick={handleCTAClick} className="inline-block border border-[#c9a96e] text-[#c9a96e] px-10 py-4 text-[13px] tracking-[0.2em] uppercase font-inter font-light transition-all duration-500 hover:bg-[#c9a96e] hover:text-[#111]" data-id="element-79">
            Mám zájem o bydlení
          </button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.button onClick={handleScrollDown} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 0.8
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-[#f5f0eb]/40 transition-colors duration-300 hover:text-[#c9a96e]" aria-label="Přejít na přehled" data-id="element-80">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-81">
          <ChevronDownIcon className="w-6 h-6" strokeWidth={1} data-id="element-82" />
        </motion.div>
      </motion.button>
    </section>;
}